<app-admin-dashboard>
  <div class="view-container">
    <p-breadcrumb class="max-w-full breadcrumb-style"
      [model]="breadcrumbMenuItems"
      [home]="breadcrumbHome"/>

    <div class="custom-tabview mt-1">
      <p-tabView [(activeIndex)]="tabActiveIndex">
        <p-tabPanel header="{{'AdminOrderDetailManagement.Tabs.OrderTabLabel' | translate}}">
          <app-admin-order-detail/>
        </p-tabPanel>
        <p-tabPanel *ngIf="(order?.importOrder?.status === 3 || order?.importOrder?.status === 4)"
          header="{{'AdminOrderDetailManagement.Tabs.LoadTabLabel' | translate}}">
          <app-admin-delivery/>
        </p-tabPanel>
        <p-tabPanel *ngIf="((order?.importOrder?.status === 3 || order?.importOrder?.status === 4)  && paidRegistered)"
          header="{{'AdminOrderDetailManagement.Tabs.OperationTabLabel' | translate}}">
          <app-admin-operation/>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</app-admin-dashboard>

